/**
 *
 * This is the class for storyMode. Handles the special navigation stuff like background-spreads, multiple spreads and closing them.
 *
 * @author Jaap
 * @since 05/11/19
 *
 */
import EventEmitter from "events";

export default class StoryMode extends EventEmitter {
    constructor() {
        super();

        this._OFFSETBREAKPOINTS = {
            "story-offset-left": [
                { point: "default", offset: { left: 50 } },
                { point: 768, offset: { left: 25 } },
                { point: 460, offset: { left: 0 } },
                { point: 360, offset: { left: 0 } },
            ],
            "story-offset-popup": [
                { point: "default", offset: { top: 20, right: 20, bottom: 20, left: 20 } },
                { point: 768, offset: { top: 0, right: 0, bottom: 0, left: 0 } },
                // {point: 480, offset: {top: 15, right: 15, bottom: 15, left: 15}},
                // {point: 360, offset: {top: 0, right: 0, bottom: 0, left: 0}},
            ],
        };

        this.pageStack = [];

        this.closeLevelBlocked = false;
        this.currentCarousel = false;
        this.carouselPointer = 0;

        this.mainStage = document.getElementById("content-slider");
        this.mainBackground = document.getElementById("story-background");
        this.backStage = document.getElementById("content-loader");
        this.storyControls = {
            closeButton: document.getElementById("story-close-level"),
            homeButton: document.getElementById("story-home"),
            openMenuButton: document.getElementById("story-open-menu"),
            carouselControlContainer: document.getElementById("story-carousel-control-container"),
            // carouselNext : document.getElementById('story-carousel-next'),
            // carouselPrevious : document.getElementById('story-carousel-previous'),
            carouselIndicator: document.getElementById("story-carousel-indicator"),
            carouselProgressBar: document.getElementById("story-carousel-progressbar-container"),
        };
        this.storyControlsMainElements = [
            this.storyControls.closeButton,
            this.storyControls.carouselControlContainer,
            this.storyControls.carouselProgressBar,
        ];

        this.storyControls.closeButton.addEventListener("click", (e) => this.closeLevel(e.target));

        if (this.storyControls.homeButton) {
            this.storyControlsMainElements.push(this.storyControls.homeButton);
            this.storyControls.homeButton.addEventListener("click", () => {
                this.goToHome();
            });
        }
        if (this.storyControls.openMenuButton) {
            this.storyControlsMainElements.push(this.storyControls.openMenuButton);
        }

        // this.storyControls.carouselNext.addEventListener('click', () => {
        //     this.carouselNext();
        // });
        // this.storyControls.carouselPrevious.addEventListener('click', () => {
        //     this.carouselPrevious();
        // });

        this.bindAnimationEnd();

        this._storyStructure = JSON.parse(document.getElementById("storySettings").innerText);
        // window.addEventListener('resize', reportWindowSize);

        //bind clicks outside the spread (on the offset) to close the current level
        this.mainStage.addEventListener("click", (event) => {
            event.target && event.target.classList.contains("spread-container") && this.closeLevel();
        });

        //expose function for external adding element to controlElements (.hide-on-homepage for example)
        window.addControlMainElement = this.addControlMainElement.bind(this);
    }

    /**
     * Add a element to the control list
     * @param element
     */
    addControlMainElement(element) {
        if (element && element.classList) {
            this.storyControlsMainElements.push(element);
        }
    }

    getStructure() {
        return this._storyStructure;
    }

    getSpreadOffsetSettings(classname) {
        let settings = false,
            width = window.innerWidth;
        if (Object.hasOwn(this._OFFSETBREAKPOINTS, classname)) {
            const breaks = this._OFFSETBREAKPOINTS[classname];

            settings = breaks[0].offset; // this is the default for the current classname

            for (let i = 1; i < breaks.length; i++) {
                // start at index 1 because 0 is the default
                if (breaks[i].point > width) {
                    settings = breaks[i].offset;
                }
            }
        }
        return settings;
    }

    getOffsetSettingsBySpreadId(spreadId) {
        const spread = this.searchSpreadId(spreadId);

        return this.getSpreadOffsetSettings(spread.classname);
    }

    moveFromBackgroundToMainStage(spread_id, classname) {
        let spread = this._moveSpreadToMainStage(spread_id, classname);
        spread && spread.classList.add("background-to-mainstage", "shade-fade-out");
        return this; //chainable
    }

    moveFromMainStageToBackground(backgroundSpreadId, previousSpreadId, classname) {
        let spread = this._moveSpreadToBackground(backgroundSpreadId, previousSpreadId);
        classname && spread && spread.classList.add(classname);
        return this; //chainable
    }
    moveFromBackStageToBackground(spread_id, previousSpreadId) {
        let spread = this._moveSpreadToBackground(spread_id, previousSpreadId);
        spread && spread.classList.add("backstage-to-background");
        return this; //chainable
    }
    moveFromBackstageToMainStage(spread_id, classname) {
        let spread = this._moveSpreadToMainStage(spread_id, classname);
        spread && spread.classList.add("backstage-to-mainstage");
        return this; //chainable
    }
    moveFromMainStageToBackStage(spread_id) {
        this._moveSpreadToBackstage(spread_id);
        return this; //chainable
    }

    _resetMainStage() {
        var elements = this.mainStage.getElementsByClassName("maglr-article");
        if (elements) {
            for (var i in elements) {
                if (typeof elements[i] == "object") {
                    this._moveSpreadToBackstage(elements[i].dataset.articleId);
                }
            }
        }
    }
    _moveSpreadToMainStage(spread_id, classname) {
        let newPage = document.getElementById(`maglr-article-${spread_id}`);
        // a shade fade cancelled by leaving the mainstage never fires animationend
        newPage && newPage.classList.remove("shade-fade-out");
        classname && newPage.classList.add(classname);
        this.setControlsClass(classname);
        newPage && this.mainStage.appendChild(newPage);

        return newPage;
    }

    _moveSpreadToBackground(spread_id, previousSpreadId) {
        let spread = document.getElementById(`maglr-article-${spread_id}`);

        if (previousSpreadId) {
            if (spread) {
                this.once(
                    "background-level-added",
                    function (previousSpreadId) {
                        this._moveSpreadToBackstage(previousSpreadId);
                    }.bind(this, previousSpreadId),
                );
            } else {
                this._moveSpreadToBackstage(previousSpreadId);
            }
        }

        spread && this.mainBackground.appendChild(spread);

        return spread;
    }

    _moveSpreadToBackstage(spread_id) {
        let spread = document.getElementById(`maglr-article-${spread_id}`);
        this.backStage.appendChild(spread);
        this.clearAnimationClasses(spread);

        return spread;
    }

    clearAnimationClasses(spread) {
        [
            "backstage-to-mainstage",
            "mainstage-to-backstage",
            "backstage-to-background",
            "background-to-backstage",
            "mainstage-to-background",
            "background-to-mainstage",
        ].forEach((name) => {
            spread.classList.remove(name);
        });
    }

    searchSpreadId(spreadId, data = this._storyStructure) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].spread_id === spreadId) {
                return data[i];
            } else if (data[i].children) {
                let res = this.searchSpreadId(spreadId, data[i].children);
                if (res) {
                    if (!res.parent) {
                        res.parent = data[i];
                    }
                    if (!res.parent_spread_id && data[i].spread_id) {
                        res.parent_spread_id = data[i].spread_id;
                    }
                    return res;
                }
            }
        }
    }

    getSiblingsBySpreadId(spreadId) {
        const spread = this.searchSpreadId(spreadId);
        if (!spread) {
            console.error("MAGLR ERROR: spreadId not found in structure", spreadId);
            return [];
        }
        const parent = this.searchSpreadId(spread.parent_spread_id);
        return parent.children;
    }

    getSiblingId(currentSpreadId, direction = 1) {
        const level = this.getSiblingsBySpreadId(currentSpreadId);
        if (level.length === 0) {
            return currentSpreadId;
        }
        const index = level.findIndex((spread) => spread.spread_id === currentSpreadId);
        const newIndex = (index + direction + level.length) % level.length;
        return level[newIndex].spread_id;
    }

    resolveAction(spread_id) {
        if (this.pageStack[0] === spread_id) {
            return { previousSpreadId: this.pageStack[0] };
        }

        let spread = this.searchSpreadId(spread_id),
            result = {
                currentSpreadId: spread_id,
                offset: this.getSpreadOffsetSettings(spread.classname),
                classname: spread.classname,
            };
        //set parent if the found spread has one
        // spread.parent && (result.parent = spread.parent);
        // spread.parent_spread_id && (result.parent_spread_id = spread.parent_spread_id)

        if (spread.parent && spread.parent.type === "carousel") {
            //same carousel?
            if (spread.parent === this.currentCarousel) {
                result.action = "replace";
                result.previousSpreadId = this.stackReplace(spread_id);
                result.direction = this.setCarouselPointer(spread_id);
            } else {
                this.mainStage.setAttribute("data-popup-transition", "in");
                this.enterCarouselMode(spread.parent, spread_id);
            }
        } else {
            this.exitCarouselMode();
        }

        if (!result.action) {
            let index = this.pageStack.indexOf(spread_id);
            if (index > -1) {
                result.previousSpreadId = this.stackPop();
                if (index > 1) {
                    result.multipop = [];

                    while (this.pageStack[0] !== spread_id) {
                        result.multipop.push(this.stackPop());
                    }
                }
                result.backgroundSpreadId = this.pageStack[1];
                result.action = "pop";
            } else {
                if (
                    !spread.parent ||
                    spread?.parent?.children?.find(({ spread_id }) => spread_id === this.pageStack[0])
                ) {
                    // sibling page on same level
                    result.action = "replace";
                    // result.backgroundSpreadId = this.pageStack[1];
                    result.previousSpreadId = this.stackReplace(spread_id);
                } else {
                    if (result.classname === "top-level") {
                        result.previousSpreadId = this.pageStack[0];
                        this.pageStack = []; // for top-levels we want to clear the pageStack to reset to the correct order
                    } else {
                        result.previousSpreadId = this.pageStack[1];
                        result.backgroundSpreadId = this.pageStack[0];
                    }

                    result.action = "push";
                    this.stackPush(spread_id);
                }
            }
        }

        // when the spread has a parent but the pageStack is 1, manipulate the current pageStack and tell which spread should be loaded in the background.
        if (this.pageStack.length === 1) {
            if (spread.parent && spread.parent_spread_id) {
                this.stackShift(spread.parent_spread_id);
                result.backgroundSpreadId = this.pageStack[1];

                //Check if the current spread is the preloaded spread.
                result.preloaded = window.fastload && window.fastload.spread_id === spread.spread_id;
            } else if (this._storyStructure[0].spread_id !== this.pageStack[0]) {
                //just push the main spread to the top of the stack
                this.stackShift(this._storyStructure[0].spread_id);
            }

            this.storyControls.closeButton.classList.remove("hideCloseLevel");
        }

        result.stackSize = this.pageStack.length;

        return result;
    }

    stackPush(spread_id) {
        return this.pageStack.unshift(spread_id);
    }

    stackPop() {
        return this.pageStack.shift();
    }

    stackReplace(spread_id) {
        let previous = this.stackPop();
        this.stackPush(spread_id);
        return previous;
    }

    stackShift(spread_id) {
        this.pageStack.push(spread_id);
    }

    closeLevel() {
        if (this.closeLevelBlocked) {
            return;
        }
        this.closeLevelBlocked = true;
        this.setBackgroundClass("close-level");
        if (this.currentCarousel) {
            this.mainStage.setAttribute("data-popup-transition", "out");
        } else {
            this.mainStage.querySelector(".maglr-article").classList.add("mainstage-to-backstage");
        }
        //if the last(second last in pagestack) level will be closed also animate the close-level button
        if (this.pageStack.length === 2) {
            this.storyControls.closeButton.classList.add("hideCloseLevel");
        }
        setTimeout(() => {
            this.closeLevelBlocked = false;
        }, 1500);
    }

    getBackgroundSpreadId() {
        return this.pageStack[1];
    }

    setControlsClass(classname) {
        const classmap = {
            "top-level": "top-level",
            "story-offset-left": "offset-left",
            "story-offset-popup": "offset-popup",
        };

        // this.setBackgroundClass(classname);
        this.storyControlsMainElements.forEach((element) => {
            ["top-level", "offset-left", "offset-popup"].forEach((removeClassname) => {
                element.classList.remove(removeClassname);
            });
            if (classname && classmap[classname]) {
                element.classList.add(classmap[classname]);
            }
        });

        if (!classname || classname === "top-level") {
            this.storyControls.closeButton.classList.remove("hideCloseLevel");
        }

        if (classname === "story-offset-left" || classname === "story-offset-popup") {
            this.storyControls.closeButton.setAttribute("tabindex", "0");
        } else {
            this.storyControls.closeButton.setAttribute("tabindex", "-1");
        }
        if (classname === "story-offset-popup") {
            this.storyControls.carouselControlContainer
                .querySelectorAll("button")
                .forEach((el) => el.setAttribute("tabindex", "0"));
            this.storyControls.homeButton && this.storyControls.homeButton.setAttribute("tabindex", "-1");
            this.storyControls.openMenuButton && this.storyControls.openMenuButton.setAttribute("tabindex", "-1");
        } else {
            this.storyControls.carouselControlContainer
                .querySelectorAll("button")
                .forEach((el) => el.setAttribute("tabindex", "-1"));
            this.storyControls.homeButton && this.storyControls.homeButton.setAttribute("tabindex", "0");
            this.storyControls.openMenuButton && this.storyControls.openMenuButton.setAttribute("tabindex", "0");
        }
    }

    setBackgroundClass(classname) {
        const classnamelist = ["top-level", "story-offset-left", "story-offset-popup"];
        if (classname) {
            if (classname !== "add-level" && classname !== "close-level") {
                classnamelist.push("add-level", "close-level");
            }
        }
        classnamelist.forEach((removeClassname) => {
            this.mainBackground.classList.remove(removeClassname);
        });
        classname && this.mainBackground.classList.add(classname);
    }

    enterCarouselMode(carousel, spread_id) {
        this.currentCarousel = carousel;
        this.setCarouselPointer(spread_id);
    }

    setCarouselPointer(spread_id) {
        let pointer = this.carouselPointer;
        this.carouselPointer = this.currentCarousel.children.findIndex((child) => child.spread_id === spread_id);
        this.storyControls.carouselIndicator.innerText = `${this.carouselPointer + 1} / ${this.currentCarousel.children.length}`;
        this.storyControls.carouselProgressBar.children[0].style.width = `${(100 / this.currentCarousel.children.length) * (this.carouselPointer + 1)}%`;
        return pointer > this.carouselPointer ? "previous" : "next";
    }

    exitCarouselMode() {
        if (this.currentCarousel) {
            this.currentCarousel = false;
            this.carouselPointer = 0;
            this.mainStage.removeAttribute("data-popup-transition");
        }
    }

    carouselNext() {
        let next =
            this.currentCarousel.children[this.carouselPointer + 1] ||
            (this.currentCarousel.loop && this.currentCarousel.children[0]);
        next && this.emit("GoToSpread", { spreadId: next.spread_id });
    }

    carouselPrevious() {
        let previous =
            this.currentCarousel.children[this.carouselPointer - 1] ||
            (this.currentCarousel.loop && this.currentCarousel.children[this.currentCarousel.children.length - 1]);
        previous && this.emit("GoToSpread", { spreadId: previous.spread_id });
    }

    getCarouselMode() {
        return this.currentCarousel;
    }

    bindAnimationEnd() {
        this.mainStage.addEventListener("animationend", (event) => {
            switch (event.animationName) {
                case "storyShadeFadeOut":
                    event.target.classList.remove("shade-fade-out");
                    break;
                case "storyMoveFromRight":
                case "storySiblingFadeIn":
                case "storySiblingFadeOut":
                    this.clearAnimationClasses(event.target);
                    this.emit("StoryTransitionDone", { spreadId: this.pageStack[0] });
                    this.setBackgroundClass("story-offset-left");
                    break;
                case "storyMoveToRight":
                    // this.emit('GoToSpread', {spreadId: this.pageStack[1] || this.resolveTopLevel(this.pageStack[0])});
                    (this.pageStack[1] && this.emit("GoToSpread", { spreadId: this.pageStack[1] })) || this.goToHome();
                    break;
                case "storyPopupFadeOut":
                case "storyPopupFadeIn":
                case "storyPopupNextOut":
                case "storyPopupNextIn":
                case "storyPopupPreviousOut":
                case "storyPopupPreviousIn":
                    // event.animationName !== 'storyPopupFadeOut' && this.mainStage.removeAttribute('data-popup-transition');

                    if (["storyPopupNextOut", "storyPopupPreviousOut"].includes(event.animationName)) {
                        let spreadId = parseInt(event.target.dataset.articleId, 10);
                        this._moveSpreadToBackstage(spreadId);
                        this.emit("StoryTransitionOutDone", { spreadId: spreadId });
                    } else if (
                        ["storyPopupNextIn", "storyPopupFadeIn", "storyPopupPreviousIn"].includes(event.animationName)
                    ) {
                        this.emit("StoryTransitionDone", { spreadId: this.pageStack[0] });
                        this.mainStage.removeAttribute("data-popup-transition");
                    } else if (event.animationName === "storyPopupFadeOut") {
                        (this.pageStack[1] && this.emit("GoToSpread", { spreadId: this.pageStack[1] })) ||
                            this.goToHome();
                    }

                    this.clearAnimationClasses(event.target);
                    this.setBackgroundClass("story-offset-popup");
                    break;
                case "fadeOutAfterLoad":
                    if (event.target && event.target.classList) {
                        event.target.classList.remove("fadeOutAfterLoad");
                    } else {
                        //fix for edge
                        let fallback = this.mainStage.querySelector(".fadeOutAfterLoad");
                        fallback && fallback.classList.remove("fadeOutAfterLoad");
                    }
                    this.emit("PageReadyToStart", { spreadId: this.pageStack[0] });
                    break;
                case "storyOffsetFromBackground":
                    this.clearAnimationClasses(event.target.parentNode);
                    break;
                case "fakeAnimation":
                    this.clearAnimationClasses(event.target);
                    // a pop to a top-level page leaves no background spread, so no
                    // later setBackgroundClass call clears close-level
                    this.mainBackground.classList.remove("close-level");
                    this.emit("StoryTransitionDone", { spreadId: this.pageStack[0] });
                    break;
            }
        });
        this.mainBackground.addEventListener("animationend", (event) => {
            let target = event.target;
            switch (event.animationName) {
                case "storyClearOffset":
                    target.parentNode.classList.remove("story-offset-left");
                    this.clearAnimationClasses(target.parentNode);
                    // this.setBackgroundClass('story-offset-left');
                    this.mainBackground.classList.remove("close-level");
                    this.mainBackground.classList.remove("add-level");
                    this.emit("background-level-added");
                    break;
                case "topLevelBackgroundOffset":
                    // this.setBackgroundClass('top-level');
                    this.mainBackground.classList.remove("close-level");
                    this.mainBackground.classList.remove("add-level");
                    this.clearAnimationClasses(target);
                    break;
                case "storyMoveFromRight":
                    // this.setBackgroundClass('story-offset-left');
                    this.clearAnimationClasses(target);
                    break;
                case "storyPopupFadeIn":
                case "storyPopupNextIn":
                case "storyPopupPreviousIn":
                    this.setBackgroundClass("story-offset-popup");
                    this.clearAnimationClasses(target);
                    break;
                case "storyPopupFadeOut":
                case "storyPopupNextOut":
                case "storyPopupPreviousOut":
                // case 'storyShadeFadeIn': // eslint-disable-line no-fallthrough
                case "fakeAnimation":
                    this.clearAnimationClasses(target);
                    break;
            }
        });
        this.backStage.addEventListener("animationend", (event) => {
            let target = event.target;
            // switch(event.animationName){
            //     case 'fakeAnimation':
            this.clearAnimationClasses(target);
            //         break;
            // }
        });
    }

    goToHome() {
        this.emit("GoToSpread", { spreadId: this._storyStructure[0].spread_id });
    }
}
